export enum VacancySuitableFor {
    Man = 'suitableForMen',
    Woman = 'suitableForWomen',
    Couple = 'suitableForCouple',
    Student = 'suitableForStudents',
}

export enum VacancyTableFilter {
    All = 'all',
    Active = 'active',
    Draft = 'draft',
    Closed = 'closed',
}
